import { render, staticRenderFns } from "./ModalWithDescription.vue?vue&type=template&id=778d90da"
import script from "./ModalWithDescription.vue?vue&type=script&lang=js"
export * from "./ModalWithDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports